import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getCropBasedMessage } from 'util/locale';
import { useSelector } from 'react-redux';
import { getActiveCropId } from 'current/currentSelectors';

const baseString = 'vra-yield-maps-historical-data';
const classString = classNames({
  [`${baseString}`]: true
});

const _isYieldDataAvailable = (yieldData) => !!yieldData.avg;

const YieldMapsHistoricalData = ({
  canViewYieldData,
  isReviewScriptStep,
  yieldMapsHistoricalData
}) => {
  const cropId = useSelector(getActiveCropId);
  const cropMessage = getCropBasedMessage({ 
    key: 'text__advanced-script__target-yield-historical-data',
    params: yieldMapsHistoricalData, 
    cropId 
  });
  return !isReviewScriptStep && canViewYieldData && _isYieldDataAvailable(yieldMapsHistoricalData) ? (
    <label className={`${classString}`}>
      {cropMessage}
    </label>
  ) : null;
};
YieldMapsHistoricalData.propTypes = {
  canViewYieldData: PropTypes.bool.isRequired,
  isReviewScriptStep: PropTypes.bool.isRequired,
  yieldMapsHistoricalData: PropTypes.object.isRequired
};
export default YieldMapsHistoricalData;
